import { select, DisposalSet } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('cbdce-result-card', (fragEl, config, meta) => {
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
